import $ from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import {
    getRoomStatus,
    getPlayers,
    getTeamAnswers,
} from "@bd-stores/game-progress";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";
import fb from "@bd-core/firebase";
import {
    maybeUpdateRoomStatus,
    updateFinalRoomAnswer,
    updateRoomAnswer,
} from "@bd-core/firebase-actions";
import interact from "interactjs";

export class LadderRoom extends BD_Component {
    constructor() {
        super();

        this.id = "ladder-room";
        this.templateID = "ladder-room-template";

        this.elms = {
            navigation: ".navigation",
            ladderProgress: ".js-ladder-progress",
            btnFinishGame: ".js-finish-game",
            btnCheckAnswers: ".js-check-answers",
            backBtn: ".app__back",
            dropzone: ".js-dropzone",
            draggableContainer: ".js-draggable",
            draggableDescription: ".js-draggable-description",
            draggableImg: ".js-draggable-img",
            dropzoneDescription: ".js-dropzone-description",
            draggablePopup: ".js-draggable-popup",
            dropzonePopup: ".js-dropzone-popup",
            dropzoneImage: ".js-dropzone-image",
            ladderSelectionContainer: ".ladderRoom__selectionPieces-inner",
            descriptionSelectionContainer:
                ".ladderRoom__selectionDescription-item",
            ladderAnswer: ".ladderRoom__ladder-img",
            ladderAnswerDescription: ".ladderRoom__ladder-popup-content",
            feedback: ".js-feedback",
        };

        this._events = this.getEvents();
        this.fbListeners = [];

        this.userAnswer = undefined;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.btnFinishGame,
                handler: this.finishGame,
            },
            {
                event: "click",
                selector: elms.btnCheckAnswers,
                handler: this.checkAnswers,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.initDraggable();
        this.listenFinishedUsers();
    }

    getModifiedData() {
        const modified = { ...this._data };

        const modifiedData = {
            ...modified,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);

        this.randomizeLadderSelection();
        this.randomizeDescriptionSelection();
    }

    randomizeLadderSelection() {
        const $ladderSelectionContainer = $(this.elms.ladderSelectionContainer);
        const $ladderSelectionItems = $ladderSelectionContainer
            .children()
            .toArray();

        for (let i = $ladderSelectionItems.length - 1; i > 1; i--) {
            const j = Math.floor(Math.random() * (i - 1)) + 1;
            [$ladderSelectionItems[i], $ladderSelectionItems[j]] = [
                $ladderSelectionItems[j],
                $ladderSelectionItems[i],
            ];
        }

        $ladderSelectionContainer.empty().append($ladderSelectionItems);
    }

    randomizeDescriptionSelection() {
        const $descriptionContainer = $(this.elms.dropzoneDescription);
        const $descriptionItems = $descriptionContainer
            .find(".ladderRoom__selectionDescription-item")
            .toArray();

        for (let i = $descriptionItems.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [$descriptionItems[i], $descriptionItems[j]] = [
                $descriptionItems[j],
                $descriptionItems[i],
            ];
        }

        $descriptionContainer
            .find(".ladderRoom__selectionDescription-item")
            .remove();
        $descriptionContainer.append($descriptionItems);
    }

    setGameState() {
        const elms = this.elms;
        const roomID = this.roomId;
        const userId = CONFIG.user.id;
        const thisRoomStatus = getRoomStatus(roomID);
        const teamAnswers = getTeamAnswers(roomID);
        this.userAnswer = teamAnswers[userId]?.pieces;

        if (this.userAnswer) {
            this.restoreUserAnswers();
        }

        const mainRoomId = CONFIG.game.rooms.find(
            (room) => room.type === "main-room",
        )?.id;
        $(elms.backBtn).attr("data-change-page", mainRoomId);
        $(elms.navigation).hide();

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (thisRoomStatus == "is-status-completed") {
            $(this.elms.btnFinishGame).prop("disabled", false);
            $(this.elms.btnCheckAnswers).prop("disabled", true);
            $(".app__page").addClass("is-room-completed");
        }
    }

    restoreUserAnswers() {
        const { ladder, description } = this.userAnswer;

        if (ladder) {
            Object.keys(ladder).forEach((index) => {
                const ladderIndex = parseInt(index);
                const isCorrect = ladder[index] === "is-correct";

                // Skip ladder piece 0 (base piece)
                if (ladderIndex === 0) {
                    return;
                }

                if (isCorrect) {
                    // Add is-completed to ladderRoom__ladder
                    const $ladder = $(`.ladderRoom__ladder`).eq(ladderIndex);
                    $ladder.addClass("is-completed is-correct");

                    // Add data-id to ladderRoom__ladder-img and copy img source
                    const $ladderImg = $ladder.find(".ladderRoom__ladder-img");
                    $ladderImg.attr("data-id", index);

                    // Find the corresponding selection piece and copy its image
                    const $selectionPiece = $(
                        `.ladderRoom__selectionPieces-item[data-id="${index}"]`,
                    );
                    const $selectionImg = $selectionPiece.find(
                        ".ladderRoom__selectionPieces-item-draggable svg",
                    );

                    if ($selectionImg) {
                        $ladderImg.empty();
                        const $imgClone = $selectionImg.clone();
                        $ladderImg.append($imgClone);
                    }

                    // Add is-completed to ladderRoom__selectionPieces-item
                    $selectionPiece.addClass("is-completed");
                }
            });
        }

        // Restore description pieces
        if (description) {
            Object.keys(description).forEach((index) => {
                const descriptionIndex = parseInt(index);
                const isCorrect = description[index] === "is-correct";

                if (isCorrect) {
                    // Add is-open to ladderRoom__ladder-popup
                    const $ladderPopup = $(`.ladderRoom__ladder-popup`).eq(
                        descriptionIndex,
                    );
                    $ladderPopup.addClass("is-open");

                    // Add data-id to ladderRoom__ladder-popup-content and copy text
                    const $popupContent = $ladderPopup.find(
                        ".ladderRoom__ladder-popup-content",
                    );
                    $popupContent.attr("data-id", index);

                    // Find the corresponding description item and copy its text
                    const $descriptionItem = $(
                        `.ladderRoom__selectionDescription-item[data-id="${index}"]`,
                    );
                    const descriptionText = $descriptionItem.text();
                    $popupContent.text(descriptionText);

                    // Add is-hiding to ladderRoom__selectionDescription-item
                    $descriptionItem.addClass("is-hiding");
                }
            });

            // Check if all description items are hidden and add is-empty class
            const $allDescriptionItems = $(
                ".ladderRoom__selectionDescription-item",
            );
            const $hidingItems = $(
                ".ladderRoom__selectionDescription-item.is-hiding",
            );

            if (
                $allDescriptionItems.length > 0 &&
                $allDescriptionItems.length === $hidingItems.length
            ) {
                $(".js-dropzone-description").addClass("is-empty");
            }
        }

        this.checkCompletionStatus();
    }

    //  INTERACTJS START
    initDraggable() {
        let closeTimeout = null;
        const self = this;

        const dropzones = document.querySelectorAll(".js-dropzone");
        const dropzonePopups = document.querySelectorAll(
            ".ladderRoom__ladder-popup",
        );

        // DRAG FUNCTION FOR LADDER SELECTION PIECES
        interact(this.elms.draggableContainer).draggable({
            modifiers: [
                interact.modifiers.restrict({
                    restriction: ".ladder-room",
                    endOnly: true,
                }),
            ],
            autoScroll: true,
            listeners: {
                start: function (event) {
                    if (closeTimeout) {
                        clearTimeout(closeTimeout);
                        closeTimeout = null;
                    }
                    event.target.classList.add("is-selected");
                    event.target
                        .closest(".ladderRoom__selectionPieces-item")
                        .classList.add("is-selected");
                    event.target.style.cursor = "grabbing";

                    var rect = event.target.getBoundingClientRect();
                    var centerX = rect.width / 2;
                    var centerY = rect.height / 2;

                    event.target.setAttribute("data-center-x", centerX);
                    event.target.setAttribute("data-center-y", centerY);

                    event.target.setAttribute("data-x", -centerX);
                    event.target.setAttribute("data-y", -centerY);
                    event.target.style.transform =
                        "translate(" + -centerX + "px, " + -centerY + "px)";
                    event.target.style.top = "100%";
                }.bind(this),
                move: dragMoveListener,
                end(event) {
                    event.target.classList.remove("is-selected");
                    event.target
                        .closest(".ladderRoom__selectionPieces-item")
                        .classList.remove("is-selected");
                    event.target.style.cursor = "grab";

                    if (!event.target.classList.contains("is-completed")) {
                        event.target.style.transform = "translate(0px, 0px)";
                        event.target.style.top = "0";
                        event.target.style.left = "0";
                        event.target.setAttribute("data-x", 0);
                        event.target.setAttribute("data-y", 0);
                    }
                },
            },
        });

        // DROP FUNCTION FOR LADDER SELECTION PIECES
        dropzones.forEach((dropzone) => {
            // @ts-ignore
            interact(dropzone).dropzone({
                accept: function (target) {
                    if (
                        target.draggableElement.classList.contains(
                            "js-draggable",
                        )
                    ) {
                        return true;
                    }

                    if (
                        target.draggableElement.classList.contains(
                            "js-draggable-img",
                        )
                    ) {
                        return true;
                    }

                    return false;
                },

                overlap: 0.2,

                ignoreFrom: "",

                ondropactivate: function (event) {
                    event.target.classList.add("drop-active");
                },
                ondragenter: function (event) {
                    var draggableElement = event.relatedTarget;
                    var dropzoneElement = event.target;

                    dropzoneElement.classList.add("drop-target");
                    draggableElement.classList.add("can-drop");
                },
                ondragleave: function (event) {
                    event.target.classList.remove("drop-target");
                    event.relatedTarget.classList.remove("can-drop");
                },
                ondrop: function (event) {
                    const droppedItem = event.relatedTarget;
                    const dropZone = event.target;

                    if (droppedItem.classList.contains("js-draggable-img")) {
                        const ladderImg = dropZone.parentElement.querySelector(
                            ".ladderRoom__ladder-img",
                        );

                        const ladderElement = dropZone.closest(
                            ".ladderRoom__ladder",
                        );
                        ladderElement.classList.add("is-completed");

                        const $dropZoneImg = $(ladderImg).find("svg");
                        const $droppedImg = $(droppedItem).find("svg");
                        const $dropZoneTitle = $(dropZone)
                            .parent()
                            .find(".ladderRoom__ladder-label");
                        const $droppedTitle = $(droppedItem)
                            .parent()
                            .find(".ladderRoom__ladder-label");

                        if ($dropZoneImg.length && $droppedImg.length) {
                            const droppedId =
                                droppedItem.getAttribute("data-id");
                            const dropZoneId =
                                ladderImg.getAttribute("data-id");

                            const swappedElementId = $(droppedItem)
                                .parent(".ladderRoom__ladder")
                                .find(this.elms.dropzone)
                                .data("id");
                            const swappedTargetId = $(dropZone)
                                .parent(".ladderRoom__ladder")
                                .find(this.elms.dropzone)
                                .data("id");
                            const $swappedElementItem = $(
                                `.ladderRoom__selectionPieces-item[data-id='${parseInt(
                                    droppedId,
                                    10,
                                )}']`,
                            );
                            $swappedElementItem
                                .find(".number")
                                .html(`${parseInt(swappedTargetId, 10) + 1}`);
                            const $swappedTargetItem = $(
                                `.ladderRoom__selectionPieces-item[data-id='${parseInt(
                                    dropZoneId,
                                    10,
                                )}']`,
                            );
                            $swappedTargetItem
                                .find(".number")
                                .html(`${parseInt(swappedElementId, 10) + 1}`);

                            const $temp = $("<div>");
                            const $tempTitle = $("<div>");

                            $dropZoneImg.replaceWith($temp);
                            $dropZoneTitle.replaceWith($tempTitle);

                            $droppedImg.replaceWith($dropZoneImg);
                            $droppedTitle.replaceWith($dropZoneTitle);

                            $temp.replaceWith($droppedImg);
                            $tempTitle.replaceWith($droppedTitle);

                            ladderImg.setAttribute("data-id", droppedId);
                            droppedItem.setAttribute("data-id", dropZoneId);
                        } else if (!$dropZoneImg.length && $droppedImg.length) {
                            $(ladderImg).append($droppedImg);
                            $dropZoneTitle.text($droppedTitle.text());

                            const id = droppedItem.getAttribute("data-id");
                            ladderImg.setAttribute("data-id", id);

                            const selectedIndex =
                                dropZone.getAttribute("data-id");
                            $(
                                `.ladderRoom__selectionPieces-item[data-id='${id}']`,
                            )
                                .find(".number")
                                .text(parseInt(selectedIndex, 10) + 1);

                            droppedItem.parentElement.classList.remove(
                                "is-completed",
                            );
                        }
                    } else {
                        const ladderImg = dropZone.parentElement.querySelector(
                            ".ladderRoom__ladder-img",
                        );
                        const replacedId = ladderImg.getAttribute("data-id");
                        const id =
                            droppedItem.parentElement.getAttribute("data-id");

                        ladderImg.setAttribute("data-id", id);

                        const selectedIndex = dropZone.getAttribute("data-id");

                        $(`.ladderRoom__selectionPieces-item[data-id='${id}']`)
                            .find(".number")
                            .text(parseInt(selectedIndex, 10) + 1);

                        const ladderElement = dropZone.closest(
                            ".ladderRoom__ladder",
                        );
                        droppedItem.parentElement.classList.add("is-completed");

                        ladderElement.classList.add("is-completed");

                        const existingImg = ladderImg.querySelector("svg");

                        if (existingImg && replacedId) {
                            const container = $(
                                ".ladderRoom__selectionPieces-inner",
                            );
                            const replacedItem = container.find(
                                `[data-id="${replacedId}"]`,
                            );
                            const newItem = container.find(`[data-id="${id}"]`);

                            existingImg.remove();
                            replacedItem.removeClass("is-completed");
                            newItem.addClass("is-completed");
                        }

                        const img = droppedItem.querySelector("svg");

                        const title = $(droppedItem)
                            .parent()
                            .find(".ladderRoom__selectionPieces-item-title");
                        const label = $(dropZone)
                            .parent()
                            .find(".ladderRoom__ladder-label");

                        if (img) {
                            const imgClone = img.cloneNode(true);
                            label.text(title.text());
                            ladderImg.appendChild(imgClone);
                        }
                    }

                    self.checkCompletionStatus();

                    if (closeTimeout) {
                        clearTimeout(closeTimeout);
                    }

                    closeTimeout = setTimeout(() => {
                        dropZone.classList.remove("drop-active", "drop-target");
                        closeTimeout = null;
                    }, 2000);
                }.bind(this),
                ondropdeactivate: function (event) {
                    event.target.classList.remove("drop-active");
                    event.target.classList.remove("drop-target");
                },
            });
        });

        // DRAG FUNCTION FOR DESCRIPTIONS SELECTION
        interact(this.elms.draggableDescription).draggable({
            modifiers: [
                interact.modifiers.restrict({
                    restriction: ".ladder-room",
                    endOnly: true,
                }),
            ],
            autoScroll: true,
            listeners: {
                start: function (event) {
                    event.target.classList.add("is-selected");
                    event.target.style.cursor = "grabbing";
                },
                move: dragMoveListener,
                end(event) {
                    event.target.classList.remove("is-selected");
                    event.target
                        .closest(".ladderRoom__selectionDescription-item")
                        .classList.remove("is-selected");
                    event.target.style.cursor = "grab";
                    if (!event.target.classList.contains("is-completed")) {
                        event.target.style.transform = "translate(0px, 0px)";
                        event.target.style.top = "0";
                        event.target.style.left = "0";
                        event.target.setAttribute("data-x", 0);
                        event.target.setAttribute("data-y", 0);
                    }
                },
            },
        });

        // DROP FUNCTION FOR DESCRIPTIONS SELECTION
        dropzonePopups.forEach((dropzone) => {
            // @ts-ignore
            interact(dropzone).dropzone({
                // accept: this.elms.draggableDescription,
                accept: function (target) {
                    if (
                        target.draggableElement.classList.contains(
                            "js-draggable-description",
                        )
                    ) {
                        return true;
                    }

                    if (
                        target.draggableElement.classList.contains(
                            "js-draggable-popup",
                        )
                    ) {
                        return true;
                    }

                    return false;
                },
                overlap: 0.2,

                ignoreFrom: "",

                ondropactivate: function (event) {
                    event.target.classList.add("drop-active");
                },
                ondragenter: function (event) {
                    var draggableElement = event.relatedTarget;
                    var dropzoneElement = event.target;

                    dropzoneElement.classList.add("drop-target");
                    draggableElement.classList.add("can-drop");
                },
                ondragleave: function (event) {
                    event.target.classList.remove("drop-target");
                    event.relatedTarget.classList.remove("can-drop");
                },
                ondrop: function (event) {
                    const droppedItem = event.relatedTarget;
                    const dropZone = event.target;

                    if (droppedItem.classList.contains("js-draggable-popup")) {
                        const dropZoneText = dropZone.querySelector(
                            ".ladderRoom__ladder-popup-content",
                        );
                        const existingId = dropZoneText.getAttribute("data-id");
                        const newId = droppedItem.getAttribute("data-id");

                        const droppedText = droppedItem.textContent;
                        const existingText = dropZoneText.textContent;

                        if (existingId && existingText.trim() !== "") {
                            const tempText = existingText;
                            const tempId = existingId;

                            dropZoneText.textContent = droppedText;
                            dropZoneText.setAttribute("data-id", newId);

                            droppedItem.textContent = tempText;
                            droppedItem.setAttribute("data-id", tempId);
                        } else {
                            dropZoneText.textContent = droppedText;
                            dropZoneText.setAttribute("data-id", newId);

                            const tempText = "";
                            const tempId = "";

                            droppedItem.textContent = tempText;
                            droppedItem.setAttribute("data-id", tempId);

                            dropZone.classList.add("is-open");

                            droppedItem.parentElement.classList.remove(
                                "is-open",
                            );
                        }
                    } else {
                        const content = dropZone.querySelector(
                            ".ladderRoom__ladder-popup-content",
                        );
                        const replacedId = content.getAttribute("data-id");
                        const id = droppedItem.getAttribute("data-id");
                        const text = droppedItem.textContent;

                        content.textContent = text;
                        content.setAttribute("data-id", id);

                        const ladderElement = dropZone;
                        ladderElement.classList.add("is-open");
                        droppedItem.classList.add("is-hiding");

                        if (replacedId) {
                            $(
                                `.ladderRoom__selectionDescription-item[data-id='${parseInt(
                                    replacedId,
                                    10,
                                )}']`,
                            ).removeClass("is-hiding");
                        }

                        const dropzoneDescription = $(
                            ".js-dropzone-description",
                        );
                        const allItems = dropzoneDescription.find(
                            ".ladderRoom__selectionDescription-item",
                        );
                        const hidingItems = dropzoneDescription.find(
                            ".ladderRoom__selectionDescription-item.is-hiding",
                        );

                        if (
                            allItems.length > 0 &&
                            allItems.length === hidingItems.length
                        ) {
                            dropzoneDescription.addClass("is-empty");
                        }
                    }

                    self.checkCompletionStatus();

                    if (closeTimeout) {
                        clearTimeout(closeTimeout);
                    }

                    closeTimeout = setTimeout(() => {
                        dropZone.classList.remove("drop-active", "drop-target");
                        closeTimeout = null;
                    }, 2000);
                },
                ondropdeactivate: function (event) {
                    event.target.classList.remove("drop-active");
                    event.target.classList.remove("drop-target");
                },
            });
        });

        // DRAG FUNCTION FOR POPUP SELECTION
        interact(this.elms.draggablePopup).draggable({
            modifiers: [
                interact.modifiers.restrict({
                    restriction: ".ladder-room",
                    endOnly: true,
                }),
            ],
            autoScroll: true,
            listeners: {
                start: function (event) {
                    event.target.classList.add("is-selected");
                    event.target.style.cursor = "grabbing";
                },
                move: dragMoveListener,
                end(event) {
                    event.target.classList.remove("is-selected");
                    event.target.style.cursor = "grab";
                    if (!event.target.classList.contains("is-refund")) {
                        event.target.style.transform = "translate(0px, 0px)";
                        event.target.style.top = "0";
                        event.target.style.left = "0";
                        event.target.setAttribute("data-x", 0);
                        event.target.setAttribute("data-y", 0);
                    }
                },
            },
        });

        // DROP FUNCTION FOR POPUP SELECTION
        interact(this.elms.dropzoneDescription).dropzone({
            accept: this.elms.draggablePopup,
            overlap: 0.2,
            ignoreFrom: "",

            ondropactivate: function (event) {
                event.target.classList.add("drop-active");
            },
            ondragenter: function (event) {
                var draggableElement = event.relatedTarget;
                var dropzoneElement = event.target;

                dropzoneElement.classList.add("drop-target");
                draggableElement.classList.add("can-drop");
            },
            ondragleave: function (event) {
                event.target.classList.remove("drop-target");
                event.relatedTarget.classList.remove("can-drop");
            },
            ondrop: function (event) {
                const droppedItem = event.relatedTarget;
                const dropZone = event.target;

                dropZone.classList.add("is-refund");

                setTimeout(() => {
                    dropZone.classList.remove("is-refund");
                }, 2000);

                droppedItem.textContent = "";
                droppedItem.parentElement.classList.remove("is-open");

                const id = droppedItem.getAttribute("data-id");
                droppedItem.setAttribute("data-id", "");

                const child = dropZone.querySelector(`[data-id="${id}"]`);
                child.classList.remove("is-hiding");

                const dropzoneDescription = $(".js-dropzone-description");
                const hidingItems = dropzoneDescription.find(
                    ".ladderRoom__selectionDescription-item.is-hiding",
                );

                if (hidingItems.length > 0) {
                    dropzoneDescription.removeClass("is-empty");
                }

                self.checkCompletionStatus();

                if (closeTimeout) {
                    clearTimeout(closeTimeout);
                }

                closeTimeout = setTimeout(() => {
                    dropZone.classList.remove("drop-active", "drop-target");
                    closeTimeout = null;
                }, 2000);
            },
            ondropdeactivate: function (event) {
                event.target.classList.remove("drop-active");
                event.target.classList.remove("drop-target");
            },
        });

        // DRAG FUNCTION FOR LADDER IMAGES SELECTION
        interact(this.elms.draggableImg).draggable({
            modifiers: [
                interact.modifiers.restrict({
                    restriction: ".ladder-room",
                    endOnly: true,
                }),
            ],
            autoScroll: true,
            listeners: {
                start: function (event) {
                    event.target.classList.add("is-selected");
                    event.target
                        .closest(".ladderRoom__ladder")
                        .classList.add("is-selected");
                    event.target
                        .closest(".ladderRoom__progress")
                        .classList.add("is-active");
                    event.target.style.cursor = "grabbing";
                },
                move: dragMoveListener,
                end(event) {
                    event.target.classList.remove("is-selected");
                    event.target
                        .closest(".ladderRoom__ladder")
                        .classList.remove("is-selected");
                    event.target
                        .closest(".ladderRoom__progress")
                        .classList.remove("is-active");
                    event.target.style.cursor = "grab";
                    if (!event.target.classList.contains("is-refund")) {
                        event.target.style.transform = "translate(0px, 0px)";
                        event.target.style.top = "0";
                        event.target.style.left = "0";
                        event.target.setAttribute("data-x", 0);
                        event.target.setAttribute("data-y", 0);
                    }
                },
            },
        });

        // DROP FUNCTION FOR LADDER IMAGES SELECTION
        interact(this.elms.dropzoneImage).dropzone({
            accept: this.elms.draggableImg,
            overlap: 0.1,
            ignoreFrom: "",
            ondropactivate: function (event) {
                event.target.classList.add("drop-active");
            },
            ondragenter: function (event) {
                var draggableElement = event.relatedTarget;
                var dropzoneElement = event.target;

                if (draggableElement) {
                    dropzoneElement.classList.add("drop-target");
                    draggableElement.classList.add("can-drop");
                }
            },
            ondragleave: function (event) {
                event.target.classList.remove("drop-target");
                if (event.relatedTarget) {
                    event.relatedTarget.classList.remove("can-drop");
                }
            },
            ondrop: function (event) {
                const droppedItem = event.relatedTarget;
                const dropZone = event.target;

                const id = droppedItem.getAttribute("data-id");
                droppedItem.setAttribute("data-id", "");

                const container = dropZone.querySelector(
                    ".ladderRoom__selectionPieces-inner",
                );

                const child = container.querySelector(`[data-id="${id}"]`);
                child.classList.remove("is-completed");

                const img = droppedItem.querySelector("svg");
                img.remove();
                droppedItem.parentElement.classList.remove("is-completed");

                self.checkCompletionStatus();

                // const draggableElement = child.querySelector(
                //     ".ladderRoom__selectionPieces-item-draggable",
                // );
                // draggableElement.appendChild(img);

                if (closeTimeout) {
                    clearTimeout(closeTimeout);
                }

                closeTimeout = setTimeout(() => {
                    dropZone.classList.remove("drop-active", "drop-target");
                    closeTimeout = null;
                }, 2000);
            },
            ondropdeactivate: function (event) {
                event.target.classList.remove("drop-active");
                event.target.classList.remove("drop-target");
            },
        });

        // RESET CURSOR DEFAULT
        interact(this.elms.draggablePopup).styleCursor(false);
        interact(this.elms.draggableContainer).styleCursor(false);
        interact(this.elms.draggableDescription).styleCursor(false);
        interact(this.elms.draggableImg).styleCursor(false);

        // DRAG MOVE LISTENER
        function dragMoveListener(event) {
            var target = event.target;

            var x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
            var y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

            target.style.transform = "translate(" + x + "px, " + y + "px)";

            target.setAttribute("data-x", x);
            target.setAttribute("data-y", y);
        }
    }

    /**
     * Check if all ladder pieces and popups are completed
     * Enable check answers button when both conditions are met
     */
    checkCompletionStatus() {
        const completedLadders = $(".ladderRoom__ladder.is-completed").length;
        const openPopups = $(".ladderRoom__ladder-popup.is-open").length;

        if (completedLadders === 6 && openPopups === 6) {
            $(this.elms.btnCheckAnswers).prop("disabled", false);
        } else {
            $(this.elms.btnCheckAnswers).prop("disabled", true);
        }
    }

    checkAnswers() {
        const elms = this.elms;
        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;
        const ladderAnswers = $(elms.ladderAnswer).toArray();
        const ladderAnswerDescriptions = $(
            elms.ladderAnswerDescription,
        ).toArray();

        const allLadderAnswers = ladderAnswers.map((answer, index) => {
            answer.parentElement.classList.remove("is-correct", "is-incorrect");
            const isCorrect =
                index === parseInt(answer.getAttribute("data-id"))
                    ? "is-correct"
                    : "is-incorrect";
            answer.parentElement.classList.add(isCorrect);
            return isCorrect;
        });
        const allLadderAnswerDescriptions = ladderAnswerDescriptions.map(
            (answer, index) => {
                answer.parentElement.classList.remove(
                    "is-correct",
                    "is-incorrect",
                );
                const isCorrect =
                    index === parseInt(answer.getAttribute("data-id"))
                        ? "is-correct"
                        : "is-incorrect";
                answer.parentElement.classList.add(isCorrect);
                return isCorrect;
            },
        );

        // Remove is-incorrect class from ladderRoom__ladder elements after 3 seconds
        setTimeout(() => {
            $(".ladderRoom__ladder.is-incorrect").removeClass("is-incorrect");
            $(".ladderRoom__ladder-popup.is-incorrect").removeClass(
                "is-incorrect",
            );
        }, 2000);

        const correctAnswers = {};
        const correctDescriptions = {};

        allLadderAnswers.forEach((answer, index) => {
            if (answer === "is-correct") {
                correctAnswers[index] = answer;
            }
        });

        allLadderAnswerDescriptions.forEach((answer, index) => {
            if (answer === "is-correct") {
                correctDescriptions[index] = answer;
            }
        });

        const answer = {
            pieces: {
                ladder: correctAnswers,
                description: correctDescriptions,
            },
            isCorrect: false,
        };

        this.userAnswer = answer.pieces;

        const ladderTotal = Object.keys(this.userAnswer.ladder).length;
        const descriptionTotal = Object.keys(
            this.userAnswer.description,
        ).length;
        const isLadderBuilt =
            ladderTotal === 6 && descriptionTotal === 6
                ? "is-correct"
                : "is-incorrect";
        $(this.elms.feedback).addClass(`is-open ${isLadderBuilt}`);
        setTimeout(() => {
            if ($(this.elms.feedback).hasClass("is-open")) {
                $(this.elms.feedback).removeClass(
                    `is-open is-correct is-incorrect`,
                );
            }
        }, 1500);

        let roomStatus = "is-status-started";
        if (isLadderBuilt === "is-correct") {
            $(this.elms.btnFinishGame).prop("disabled", false);
            $(this.elms.btnCheckAnswers).prop("disabled", true);
            roomStatus = "is-status-completed";
            answer.isCorrect = true;
        } else {
            $(this.elms.btnFinishGame).prop("disabled", true);
            $(this.elms.btnCheckAnswers).prop("disabled", false);
        }

        updateRoomAnswer(roomID, {
            [currentPlayerId]: answer,
        });
        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    // RESET LADDER AND DESCRIPTION SELECTION
    resetLadder() {
        $(this.elms.draggableContainer).each((index, element) => {
            const $element = $(element);
            $element.removeClass("is-completed");
            $element.css({
                transform: "translate(0px, 0px)",
                top: "0",
                left: "0",
            });
            $element.attr("data-x", 0);
            $element.attr("data-y", 0);
        });

        $(this.elms.draggableDescription).each((index, element) => {
            const $element = $(element);
            $element.removeClass("is-hiding");
            $element.css({
                transform: "translate(0px, 0px)",
                top: "0",
                left: "0",
            });
            $element.attr("data-x", 0);
            $element.attr("data-y", 0);
        });

        $(this.elms.draggablePopup).each((index, element) => {
            const $element = $(element);
            $element.removeClass("is-refund");
            $element.css({
                transform: "translate(0px, 0px)",
                top: "0",
                left: "0",
            });
            $element.attr("data-x", 0);
            $element.attr("data-y", 0);
        });

        $(this.elms.draggableImg).each((index, element) => {
            const $element = $(element);
            $element.removeClass("is-refund");
            $element.css({
                transform: "translate(0px, 0px)",
                top: "0",
                left: "0",
            });
            $element.attr("data-x", 0);
            $element.attr("data-y", 0);
        });

        $(".ladderRoom__ladder")
            .not(":first")
            .removeClass("is-completed is-selected");

        $(".ladderRoom__selectionPieces-item")
            .not('[data-id="0"]')
            .removeClass("is-completed is-selected");
        $(".ladderRoom__selectionDescription-item").removeClass(
            "is-selected is-hiding",
        );

        $(".ladderRoom__ladder-popup").removeClass("is-open");
        $(".js-dropzone-description").removeClass("is-empty");

        $(".ladderRoom__ladder-img")
            .not('[data-id="0"]')
            .each((index, element) => {
                const $element = $(element);
                $element.attr("data-id", "");
                $element.empty();
            });

        $(".ladderRoom__ladder-popup-content").each((index, element) => {
            const $element = $(element);
            $element.text("");
            $element.attr("data-id", "");
        });

        $(".js-dropzone").removeClass("drop-active drop-target");
        $(".js-draggable").removeClass("can-drop");

        this.checkCompletionStatus();
    }

    finishGame() {
        const roomID = this.roomId;
        const gameProgress = getState().gameProgress;

        if (gameProgress.allRoomCompleted) {
            updateFinalRoomAnswer(roomID, {
                [CONFIG.user.id]: CONFIG.user.id,
            });
        }
    }

    finishedUsersListener(snapshot) {
        const value = snapshot.val();
        const readyUsers = bdjs.indexedObjectToArray(value);
        const players = getPlayers();

        if (readyUsers.length) {
            let allReady = true;

            players.forEach((player) => {
                const isReady = readyUsers.find((id) => id == player.userId);
                if (player.isOnline && !isReady) allReady = false;
            });

            const totalHintUsed = Object.values(
                getState().gameProgress.hintUsed,
            ).filter(Boolean).length;

            if (allReady) {
                bdjs.goAsync(
                    bdapi.post("game/finish-game", {
                        middle_state: getState().gameProgress.isMiddleState
                            ? 1
                            : 0,
                        hint_used: totalHintUsed,
                    }),
                );
            }
        }
    }

    maybeReadyToFinish() {
        const roomID = this.roomId;
        fb.get(`${fb.roomsPath}/${roomID}/finalAnswers`).then((data) => {
            this.finishedUsersListener(data);
        });
    }

    listenFinishedUsers() {
        const roomID = this.roomId;
        const path = `${fb.roomsPath}/${roomID}/finalAnswers`;

        this.fbListeners.push(
            fb.onValue(path, this.finishedUsersListener),
            fb.onValue(fb.playersPath, this.maybeReadyToFinish.bind(this)),
        );
    }

    beforeDestroy() {
        const dropzones = document.querySelectorAll(".js-dropzone");
        dropzones.forEach((dropzone) => {
            // @ts-ignore
            interact(dropzone).unset();
        });

        const dropzonePopups = document.querySelectorAll(
            ".ladderRoom__ladder-popup",
        );
        dropzonePopups.forEach((popup) => {
            // @ts-ignore
            interact(popup).unset();
        });

        if (this.elms && this.elms.draggableContainer) {
            $(this.elms.draggableContainer).each(function () {
                interact(this).unset();
            });
        }

        if (this.elms && this.elms.draggableDescription) {
            $(this.elms.draggableDescription).each(function () {
                interact(this).unset();
            });
        }

        if (this.elms && this.elms.draggablePopup) {
            $(this.elms.draggablePopup).each(function () {
                interact(this).unset();
            });
        }

        if (this.elms && this.elms.dropzoneDescription) {
            $(this.elms.dropzoneDescription).each(function () {
                interact(this).unset();
            });
        }

        if (this.elms && this.elms.dropzonePopup) {
            $(this.elms.dropzonePopup).each(function () {
                interact(this).unset();
            });
        }
        if (this.elms && this.elms.dropzoneImage) {
            $(this.elms.dropzoneImage).each(function () {
                interact(this).unset();
            });
        }
        if (this.elms && this.elms.draggableImg) {
            $(this.elms.draggableImg).each(function () {
                interact(this).unset();
            });
        }

        this.fbListeners.forEach((fn) => fn.call());
        this.fbListeners = [];
        $(this.elms.navigation).show();
    }
}
